import React, { useContext } from 'react'
import { LocaleContext } from '../routes'
import { Content, Title } from '../styles/elements'
import { GiftInstruction, GiftLink, PaidGiftBody } from '../styles/gift'

export default ({ instruction, description, link }) => {
  const locale = useContext(LocaleContext)
  return (
    <PaidGiftBody id="gift-body">
      <Content>
        {description}
      </Content>
      {instruction &&
        <GiftInstruction>
          <Title>{locale.HOW_TO_USE}:</Title>
          <Content>
            {instruction}
          </Content>
          {link &&
            <GiftLink
              href={link}
              target="_blank"
              rel="noopener noreferrer nofollow"
            >
              {link}
            </GiftLink>
          }
        </GiftInstruction>
      }
    </PaidGiftBody>
  )
}
